export const parseAssetPath = (url: string) => {
  if (!url) {
    return ''
  }

  return url.replace('a.storyblok.com', 'assets.airbaltic.com')
}
